import pluralize from 'pluralize';

export const checkStudyUserBelongsToTeam = (user_id: number, team: Team, accountUsers: TeamUser[]): boolean => {
  const accountUser = accountUsers.find((accountUser) => accountUser.id === user_id);
  return (accountUser && accountUser.role === 'admin') || team.users.some((teamUser) => teamUser.id === user_id);
};

export const notOnTeamHeading = (
  teamUsersNotOnStudyTeamCount: number,
  visibility_permission_condition?: PermissionCondition
): string =>
  `${teamUsersNotOnStudyTeamCount} ${pluralize('collaborator', teamUsersNotOnStudyTeamCount)} ${
    visibility_permission_condition === 'allow_if_team_match' ? 'can’t view' : 'may not be able to edit'
  } this study as they’re not on the team`;
